import React from 'react';

interface Props {
  amountOfRemainingValues: number;
}

const RemainingValuesMessage = ({ amountOfRemainingValues }: Props) => {
  if (amountOfRemainingValues === 0) {
    return null;
  }

  const message =
    amountOfRemainingValues === 1
      ? `${amountOfRemainingValues} value is not displayed`
      : `${amountOfRemainingValues} values are not displayed`;

  return <div className='text-xs'>{message}</div>;
};

export default RemainingValuesMessage;
